export function schema_pdf() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column_name: {
				type: "string",
				title: "Colonne des noms de fichiers",
				default: "name",
			},
			column_url: {
				type: "string",
				title: "Colonne des urls",
				default: "url",
			},
			column_page: {
				type: "string",
				title: "Colonne des numéros de pages",
				default: "page",
			},
			column_count: {
				type: "string",
				title: "Colonne du nombre de pages",
				default: "",
			},
			column_new_name: {
				type: "string",
				title: "Colonne des noms des pdf découpés",
				default: "split_name",
			},
			split: {
				type: "object",
				title: "Découpe",
				properties: {
					active: {
						type: "boolean",
						title: "Activer",
						format: "checkbox",
					},
					column_page: {
						type: "string",
						title: "Colonne des plages de pages à extraire (ex : 1-3) — si vide, découpe page par page",
						default: "",
					},
					column_new_url: {
						type: "string",
						title: "Colonne pour l'url du pdf produit — si vide, écrase la colonne url source",
						default: "",
					},
				},
			},
			fusion: {
				type: "object",
				title: "Fusion",
				properties: {
					active: {
						type: "boolean",
						title: "Activer",
						format: "checkbox",
					},
				},
			},
			rotate: {
				type: "object",
				title: "Rotation",
				properties: {
					active: {
						type: "boolean",
						title: "Activer",
						format: "checkbox",
					},
					column_rotate: {
						type: "string",
						title: "Colonne de rotation",
						default: "rotation",
					},
					inverse: {
						type: "boolean",
						title: "Inverser le sens de rotation",
						format: "checkbox",
					},
				},
			},
		},
	};
}
